import { render, staticRenderFns } from "./CalfHealth.vue?vue&type=template&id=b4c7a40c&"
import script from "./CalfHealth.vue?vue&type=script&lang=js&"
export * from "./CalfHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports